import React from 'react'
import './HiringCard.css'
import { ReactComponent as PinIcon } from '../../Assets/img/home-page/hiring-location.svg'
import { ReactComponent as ContractIcon } from '../../Assets/img/home-page/hiring-contract.svg'

const HiringCard = ({
  title,
  salaryRange,
  location,
  contractType,
  hiringType
}) => {
  const cardClass = hiringType && !hiringType.includes('Offre') 
    ? 'hiring-card hiring-card-alt' 
    : 'hiring-card';
    
  return (
    <div className={cardClass}>
      <div className="hiring-title">{String(title || '').toUpperCase()}</div>
      <div className="hiring-salary">{salaryRange}</div>
      {hiringType && (
        <div className="hiring-type">{hiringType}</div>
      )}
      <div className="hiring-row">
        <PinIcon className="hiring-icon hiring-location-icon" aria-hidden />
        <span className="hiring-text">{String(location || '')}</span>
      </div>
      <div className="hiring-row">
        <ContractIcon className="hiring-icon hiring-contract-icon" aria-hidden />
        <span className="hiring-text">{String(contractType || '')}</span>
      </div>
    </div>
  )
}

export default HiringCard
